/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GitHub } from '../fn/webhook/git-hub';
import { GitHub$Params } from '../fn/webhook/git-hub';
import { TeamCity } from '../fn/webhook/team-city';
import { TeamCity$Params } from '../fn/webhook/team-city';
import { Test } from '../fn/webhook/test';
import { Test$Params } from '../fn/webhook/test';

@Injectable({ providedIn: 'root' })
export class WebhookApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiWebhookTestTestGet()` */
  static readonly ApiWebhookTestTestGetPath = '/api/Webhook/Test/test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Test()` instead.
   *
   * This method doesn't expect any request body.
   */
  Test$Response(params?: Test$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Test(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Test$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Test(params?: Test$Params, context?: HttpContext): Observable<void> {
    return this.Test$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebhookGitHubPost()` */
  static readonly ApiWebhookGitHubPostPath = '/api/Webhook/GitHub';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GitHub()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  GitHub$Response(params?: GitHub$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return GitHub(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GitHub$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  GitHub(params?: GitHub$Params, context?: HttpContext): Observable<void> {
    return this.GitHub$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiWebhookTeamCityPost()` */
  static readonly ApiWebhookTeamCityPostPath = '/api/Webhook/TeamCity';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `TeamCity()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  TeamCity$Response(params?: TeamCity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return TeamCity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `TeamCity$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  TeamCity(params?: TeamCity$Params, context?: HttpContext): Observable<void> {
    return this.TeamCity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
